import {FlatList, ScrollView, View, ViewStyle} from 'react-native';
import React from 'react';
import {useTheme} from 'contexts/ThemeContext';
import CustomXAxis from 'components/atoms/customXAxis';
import StudentList from 'components/molecules/studentsList';
import {useAnalyticsStore} from 'contexts/StoreContext';
import {observer} from 'mobx-react';
import {CustomChartProps} from '.';
import CreateChart from '../createChart';
import strings from '../../../translations';
import styleSheet from './styles';

const CustomChart = observer((props: CustomChartProps) => {
  const theme = useTheme();
  const styles = styleSheet(theme);
  const analyticStore = useAnalyticsStore();

  const setStudentList = () => {
    switch (props.chartType) {
      case strings.analyticsScreen.speakers:
        return props.transcriptionsStudentData;
      case strings.analyticsScreen.reaction:
        return props.reactionStudentData;
    }
  };

  const LeftSide = (
    <View style={[styles.defaultStyle, styles.studentContainerWeb]}>
      <StudentList
        data={setStudentList()}
        onPress={value => props.onPressStudenListItem(value)}
        containerStyle={styles.studentListContainerStyleWeb}
        contentContainerStyle={styles.studentContentContainerStyle}
        flatListStyle={styles.borderRadius}
        textStyle={styles.studentTitleStyleWeb}
        itemContainerStyle={styles.studentItemContainerStyle}
        itemSeparatorStyle={styles.studentItemSeparatorStyle}
      />
    </View>
  );

  const RightSide = (
    <View style={styles.chartContainerWeb}>
      <ScrollView
        contentContainerStyle={[
          styles.defaultStyle,
          styles.scrollViewContentContainerStyleWeb,
        ]}
        style={styles.scrollViewStyle}
        showsHorizontalScrollIndicator={false}
        horizontal>
        <FlatList
          scrollEnabled={false}
          data={setStudentList()}
          renderItem={({item, index}) => {
            analyticStore.selectStudent(item.email);

            return (
              <View
                key={`${index} + ${item.email}`}
                style={
                  styles.multipleChartsMargin(
                    index,
                    props.tickValueArray,
                  ) as ViewStyle
                }>
                <CreateChart
                  chartType={props.chartType}
                  speakerDataForChart={props.speakerDataForChart}
                  reactionDataForChart={props.reactionDataForChart}
                />
              </View>
            );
          }}
        />

        <CustomXAxis tickValueArray={props.tickValueArray} />
      </ScrollView>
    </View>
  );

  return (
    <View style={[styles.defaultStyle, styles.contentContainerStyleWeb]}>
      {LeftSide}
      {RightSide}
    </View>
  );
});

export default CustomChart;
